var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 15.8334V8.75008C16.6667 8.62071 16.6366 8.49312 16.5787 8.3774C16.5209 8.26169 16.4369 8.16104 16.3334 8.08341L10.5 3.70841C10.3558 3.60023 10.1803 3.54175 10 3.54175C9.81973 3.54175 9.64429 3.60023 9.50004 3.70841L3.66671 8.08341C3.56321 8.16104 3.47921 8.26169 3.42135 8.3774C3.36349 8.49312 3.33337 8.62071 3.33337 8.75008V15.8334C3.33337 16.0544 3.42117 16.2664 3.57745 16.4227C3.73373 16.579 3.94569 16.6667 4.16671 16.6667H15.8334C16.0544 16.6667 16.2663 16.579 16.4226 16.4227C16.5789 16.2664 16.6667 16.0544 16.6667 15.8334Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3f4fdc1547f3f1f1039736862ebb72b5.svg";
export { ForwardRef as ReactComponent };